"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function NewGmail16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 17, fill: "none", viewBox: "0 0 16 17" }, props),
        react_1.default.createElement("g", { clipPath: "url(#a)" },
            react_1.default.createElement("path", { fill: "#4285F4", d: "M1.09 14.499h2.546V8.317L0 5.59v7.818c0 .604.49 1.09 1.09 1.09Z" }),
            react_1.default.createElement("path", { fill: "#34A853", d: "M12.363 14.499h2.546c.603 0 1.09-.49 1.09-1.091V5.59l-3.636 2.727" }),
            react_1.default.createElement("path", { fill: "#FBBC04", d: "M12.363 3.59v4.727L16 5.59V4.136c0-1.35-1.54-2.119-2.618-1.31" }),
            react_1.default.createElement("path", { fill: "#EA4335", d: "M3.637 8.317V3.59L8 6.863l4.364-3.273v4.727L8 11.59" }),
            react_1.default.createElement("path", { fill: "#C5221F", d: "M0 4.136V5.59l3.636 2.727V3.59l-1.018-.764C1.538 2.017 0 2.786 0 4.136Z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "a" },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 2.5h16v12H0z" }))));
}
function NewGmail16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(NewGmail16Svg, Object.assign({}, svgProps)));
}
exports.default = NewGmail16;
//# sourceMappingURL=NewGmail16.js.map